export default "__VITE_ASSET__B2Fht3Mf__"